// Pure helper for the Create Fantasy Fam modal's invite rows. Kept separate
// from the component so it's unit-testable without a DOM.

/**
 * cleanInviteList — normalize the raw invite-row inputs into the array sent as
 * `invites` on POST /v1/fantasy-fams: trim each, drop blanks, and dedupe
 * case-insensitively (the worker resolves handles/emails/usernames
 * case-insensitively). First-occurrence order + casing is preserved.
 */
export function cleanInviteList(raw: string[]): string[] {
	const seen = new Set<string>();
	const out: string[] = [];
	for (const entry of raw) {
		const trimmed = entry.trim();
		if (!trimmed) continue;
		const key = trimmed.toLowerCase();
		if (seen.has(key)) continue;
		seen.add(key);
		out.push(trimmed);
	}
	return out;
}
